import { useRouter } from 'next/router';

import { PAGE_ROUTE_TO_ORGANIZATION_TYPE_MAP } from '@constants/organizationType';
import type { IRouterQuery } from '@interfaces/routes';

export function useOrganizationType() {
  const router = useRouter() as TRouter<IRouterQuery>;
  const { query } = router;

  return PAGE_ROUTE_TO_ORGANIZATION_TYPE_MAP[query.organizationType];
}
